function isRedPointActive(multiplier: number): boolean {
  return multiplier !== -1
}

type RedPointsData = {
  amount: number
  multiplier: number
  endDate?: string
  startDate?: string
}

type ProductRedPoints = {
  multiplierRP: number
  redPoints: number
  redPointsIsActive: boolean
  redPointsMultiplierIsValid: boolean
  endDateRP: string
}

export function isMultipleRedPointsValid(
  multiplier: number,
  startDateRP: string,
  endDateRP: string
): boolean {
  if (multiplier < 0) return false

  const currentDate = Date.now()
  const startDate = new Date(startDateRP || 0).getTime()
  const endDate = new Date(endDateRP || 0).getTime()

  const isStartDateValid = endDate === 0 && currentDate > startDate
  const isEndDateValid = startDate === 0 && endDate > currentDate
  const isCurrentDateInRange =
    currentDate >= startDate && currentDate <= endDate

  return isStartDateValid || isEndDateValid || isCurrentDateInRange
}

export const getRedpoints = (
  redPoints: RedPointsData | undefined
): ProductRedPoints => {
  const {
    amount = 0,
    multiplier = 1,
    endDate = '',
    startDate = '',
  } = redPoints || {}

  const isRedPointsActive = isRedPointActive(multiplier)
  const isRpMultiplierValid =
    isRedPointsActive &&
    isMultipleRedPointsValid(multiplier, startDate, endDate)

  function calcRP(
    redPointsMultiplierIsValid: boolean,
    multiplierRP: number,
    amt: number
  ): number {
    return redPointsMultiplierIsValid && amount > 0
      ? amt / multiplierRP
      : amt || 0
  }

  function getMultiplier(multiplierRP: number, isRPActive: boolean): number {
    return multiplierRP === -1 && isRPActive ? 1 : multiplierRP
  }

  return {
    multiplierRP: getMultiplier(multiplier, isRedPointsActive),
    // The following line should be changed to use 'amount' directly without
    // division when the old PDP is decomissioned.
    // Use of 'getMultipliedRedPoints()' should be removed as well.
    redPoints: calcRP(isRpMultiplierValid, multiplier, amount),
    redPointsIsActive: isRedPointsActive,
    redPointsMultiplierIsValid: isRpMultiplierValid,
    endDateRP: endDate,
  }
}
